module.exports = __webpack_public_path__ + "img/t1-2.4d4a3437.png";